<script lang="ts">
  import "../../app.css";
  import HomeIcon from "$lib/icons/HomeIcon.svelte";
  import LevelUpIcon from "$lib/icons/LevelUpIcon.svelte";
  import PromotionsIcon from "$lib/icons/PromotionsIcon.svelte";
  import SupportIcon from "$lib/icons/SupportIcon.svelte";
  import {leftSidebarIsOpenStore, showHeaderBanner, userToken} from "$lib/stores";
  import {fly} from "svelte/transition";
  import {locale, translate} from "$lib/i18n";
  import {page} from "$app/stores";
  import {toasts} from "$lib/stores/toastStores";
  import {goto} from "$app/navigation";
  import GridIcon from "$lib/icons/GridIcon.svelte";
  import {onMount} from "svelte";

  let sideBarIsOpen = false;
  let sideBarWidth = 'w-56';
  export let data: any;
  let liveChatReady = false;
  let slotsDropdownOpen = false;

  leftSidebarIsOpenStore.subscribe(value => {
    sideBarIsOpen = value;
    sideBarWidth = value ? 'w-56 fixed md:w-56' : 'w-16 fixed md:w-16';
  });

  const toggleSideBar = () => {
    leftSidebarIsOpenStore.update(value => !value);
  }

  const toggleSlotsDropdown = (e) => {
    if (!sideBarIsOpen) return;
    e.preventDefault();
    slotsDropdownOpen = !slotsDropdownOpen;
  }

  onMount(() => {
    if (window.LiveChatWidget) {
      window.LiveChatWidget.on('ready', function() {
        liveChatReady = true;
      });
    } else {
      console.error('LiveChatWidget is not defined');
    }
  });

  function redirectToBonusCenter() {
    if ($userToken || data.token) {
      goto(`/${$locale}/bonus`)
      return
    }
    toasts.send('Please login to access the bonus center', 'error');
  }

  function openChat() {
    if (liveChatReady) {
      window.LiveChatWidget.call('maximize');
    } else {
      console.error('LiveChat widget not ready yet');
    }
  }

  // Check if any casino-related page is active
  $: casinoActive = $page.url.pathname.includes(`/${$locale}/casino`);
</script>

<div class="relative">
  <button
          on:click={() => toggleSideBar()}
          class="fixed z-50 left-[216px] md:left-[216px] top-20 w-7 h-7 flex items-center justify-center bg-[#FF3E00] rounded-full cursor-pointer shadow-md hover:bg-[#FF5722] transition-all duration-200 hidden md:flex"
          class:left-[60px]={!sideBarIsOpen}
          class:md:left-[60px]={!sideBarIsOpen}
  >
    <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-white transition-transform duration-200 {sideBarIsOpen ? '' : 'rotate-180'}"
    >
      <path d="m15 18-6-6 6-6"/>
    </svg>
  </button>

  <aside
          transition:fly={{ x: -300, duration: 300 }}
          class="z-20 ease-in-out duration-150 bg-[#191D25] h-screen top-0 hidden md:block fixed {sideBarWidth} {sideBarIsOpen ? 'overflow-y-auto' : 'overflow-hidden'}"
  >

    <div class="h-20"></div>

    <div class="p-2 pt-2">
      <button
              on:click={() => redirectToBonusCenter()}
              data-label="Bonus Center"
              class="w-full group hover:bg-[#1A1F2E] transition-all duration-200 rounded-md relative overflow-hidden {sideBarIsOpen ? 'h-16 p-2' : 'menu-link h-12 p-2'}"
      >
        <div class="flex items-center h-full">
          {#if sideBarIsOpen}
            <div class="flex items-center bg-gradient-to-r from-[#FF3E00] to-[#FF5722] rounded-md p-1.5 w-full">
              <div class="min-w-8 w-8 h-8 flex items-center justify-center bg-[#101624]/30 rounded-md">
                <svg class="w-8 h-8" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <linearGradient id="sidenavGradient1" x1="4.1" y1="9.8" x2="19.9" y2="9.8" gradientUnits="userSpaceOnUse">
                      <stop offset="0" stop-color="#fdf386"/>
                      <stop offset="0.93" stop-color="#ec4946"/>
                    </linearGradient>
                    <linearGradient id="sidenavGradient2" x1="14" y1="19.3" x2="19.1" y2="19.3" xlink:href="#sidenavGradient1"/>
                    <linearGradient id="sidenavGradient3" x1="5.1" y1="19.2" x2="10.2" y2="19.2" xlink:href="#sidenavGradient1"/>
                    <linearGradient id="sidenavGradient4" x1="6.95" y1="9.9" x2="17.2" y2="9.9" xlink:href="#sidenavGradient1"/>
                  </defs>
                  <rect fill="#1b2437" width="24" height="24"/>
                  <path fill="url(#sidenavGradient1)" d="M19.9,9.85c0-.7-.3-1.3-.7-1.4A1.53,1.53,0,0,0,19.3,7c-.3-.6-.8-1.1-1.2-1a1.39,1.39,0,0,0-.5-1.6,1.41,1.41,0,0,0-1.5-.5,1.62,1.62,0,0,0-1-1.2,1.49,1.49,0,0,0-1.6.1,1.49,1.49,0,0,0-1.4-.7c-.7,0-1.3.3-1.4.7A1.61,1.61,0,0,0,9,2.55c-.6.3-1.1.8-1,1.2a1.41,1.41,0,0,0-1.5.5A1.42,1.42,0,0,0,6,5.85a1.48,1.48,0,0,0-1.2,1,1.77,1.77,0,0,0,0,1.6c-.4.1-.7.7-.7,1.4s.3,1.3.7,1.4a1.46,1.46,0,0,0-.1,1.6c.3.7.8,1.1,1.3,1a1.41,1.41,0,0,0,.5,1.5c.5.5,1.1.7,1.4.5a1.62,1.62,0,0,0,1,1.2,1.48,1.48,0,0,0,1.6-.2c.1.4.7.7,1.4.7s1.3-.3,1.4-.7a1.66,1.66,0,0,0,1.6.2c.6-.3,1.1-.7,1.1-1.2a1.4,1.4,0,0,0,1.4-.5,1.41,1.41,0,0,0,.5-1.5c.4.1,1-.3,1.3-1a1.33,1.33,0,0,0,0-1.6C19.6,11.15,19.9,10.55,19.9,9.85ZM12,15.75a5.89,5.89,0,0,1-5.8-5.9,5.8,5.8,0,0,1,11.6,0A5.89,5.89,0,0,1,12,15.75Z"/>
                  <path fill="url(#sidenavGradient2)" d="M16.6,16.75a2.37,2.37,0,0,1-1.3,1.1,3.55,3.55,0,0,1-1,.2H14A5.76,5.76,0,0,0,15.7,22l1-2.2,2.4.6a7.41,7.41,0,0,1-1.7-3.7A2.2,2.2,0,0,0,16.6,16.75Z"/>
                  <path fill="url(#sidenavGradient3)" d="M8.7,17.85a2.07,2.07,0,0,1-1.3-1.1,1.42,1.42,0,0,1-.6-.2,7.41,7.41,0,0,1-1.7,3.7l2.4-.6,1,2.2A5.76,5.76,0,0,0,10.2,18a4.33,4.33,0,0,1-.5.1A3.55,3.55,0,0,1,8.7,17.85Z"/>
                  <path fill="url(#sidenavGradient4)" d="M12,4.85A5,5,0,0,0,7.84,7,5,5,0,0,0,12,15h.1a5.12,5.12,0,0,0,5.1-5.1A5.12,5.12,0,0,0,12,4.85Zm2.92,4.77-1.12,1.1.26,1.54a.41.41,0,0,1-.6.43L12.08,12l-1.39.72a.41.41,0,0,1-.6-.43l.26-1.54L9.23,9.62a.41.41,0,0,1,.23-.7L11,8.69l.69-1.4a.42.42,0,0,1,.75,0l.69,1.4,1.55.23A.41.41,0,0,1,14.92,9.62Z"/>
                </svg>
              </div>
              <div class="ml-2">
                <span class="font-bold text-white block text-sm">{$translate('Bonus Center')}</span>
                <span class="text-[10px] text-white/80">Daily Free Bonus Game</span>
              </div>
            </div>
          {:else}
            <div class="min-w-8 w-8 h-8 flex items-center justify-center bg-[#FF3E00] rounded-md">
              <svg class="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                  <linearGradient id="sidenavSmallGradient1" x1="4.1" y1="9.8" x2="19.9" y2="9.8" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#fdf386"/>
                    <stop offset="0.93" stop-color="#ec4946"/>
                  </linearGradient>
                  <linearGradient id="sidenavSmallGradient2" x1="14" y1="19.3" x2="19.1" y2="19.3" xlink:href="#sidenavSmallGradient1"/>
                  <linearGradient id="sidenavSmallGradient3" x1="5.1" y1="19.2" x2="10.2" y2="19.2" xlink:href="#sidenavSmallGradient1"/>
                  <linearGradient id="sidenavSmallGradient4" x1="6.95" y1="9.9" x2="17.2" y2="9.9" xlink:href="#sidenavSmallGradient1"/>
                </defs>
                <rect fill="#1b2437" width="24" height="24"/>
                <path fill="url(#sidenavSmallGradient1)" d="M19.9,9.85c0-.7-.3-1.3-.7-1.4A1.53,1.53,0,0,0,19.3,7c-.3-.6-.8-1.1-1.2-1a1.39,1.39,0,0,0-.5-1.6,1.41,1.41,0,0,0-1.5-.5,1.62,1.62,0,0,0-1-1.2,1.49,1.49,0,0,0-1.6.1,1.49,1.49,0,0,0-1.4-.7c-.7,0-1.3.3-1.4.7A1.61,1.61,0,0,0,9,2.55c-.6.3-1.1.8-1,1.2a1.41,1.41,0,0,0-1.5.5A1.42,1.42,0,0,0,6,5.85a1.48,1.48,0,0,0-1.2,1,1.77,1.77,0,0,0,0,1.6c-.4.1-.7.7-.7,1.4s.3,1.3.7,1.4a1.46,1.46,0,0,0-.1,1.6c.3.7.8,1.1,1.3,1a1.41,1.41,0,0,0,.5,1.5c.5.5,1.1.7,1.4.5a1.62,1.62,0,0,0,1,1.2,1.48,1.48,0,0,0,1.6-.2c.1.4.7.7,1.4.7s1.3-.3,1.4-.7a1.66,1.66,0,0,0,1.6.2c.6-.3,1.1-.7,1.1-1.2a1.4,1.4,0,0,0,1.4-.5,1.41,1.41,0,0,0,.5-1.5c.4.1,1-.3,1.3-1a1.33,1.33,0,0,0,0-1.6C19.6,11.15,19.9,10.55,19.9,9.85ZM12,15.75a5.89,5.89,0,0,1-5.8-5.9,5.8,5.8,0,0,1,11.6,0A5.89,5.89,0,0,1,12,15.75Z"/>
                <path fill="url(#sidenavSmallGradient2)" d="M16.6,16.75a2.37,2.37,0,0,1-1.3,1.1,3.55,3.55,0,0,1-1,.2H14A5.76,5.76,0,0,0,15.7,22l1-2.2,2.4.6a7.41,7.41,0,0,1-1.7-3.7A2.2,2.2,0,0,0,16.6,16.75Z"/>
                <path fill="url(#sidenavSmallGradient3)" d="M8.7,17.85a2.07,2.07,0,0,1-1.3-1.1,1.42,1.42,0,0,1-.6-.2,7.41,7.41,0,0,1-1.7,3.7l2.4-.6,1,2.2A5.76,5.76,0,0,0,10.2,18a4.33,4.33,0,0,1-.5.1A3.55,3.55,0,0,1,8.7,17.85Z"/>
                <path fill="url(#sidenavSmallGradient4)" d="M12,4.85A5,5,0,0,0,7.84,7,5,5,0,0,0,12,15h.1a5.12,5.12,0,0,0,5.1-5.1A5.12,5.12,0,0,0,12,4.85Zm2.92,4.77-1.12,1.1.26,1.54a.41.41,0,0,1-.6.43L12.08,12l-1.39.72a.41.41,0,0,1-.6-.43l.26-1.54L9.23,9.62a.41.41,0,0,1,.23-.7L11,8.69l.69-1.4a.42.42,0,0,1,.75,0l.69,1.4,1.55.23A.41.41,0,0,1,14.92,9.62Z"/>
              </svg>
            </div>
          {/if}
        </div>
      </button>
    </div>

    <!-- Main Navigation Menu -->
    <div class="flex-grow px-2 py-2 {sideBarIsOpen ? 'overflow-y-auto' : 'overflow-hidden'}">
      <ul class="flex flex-col gap-0.5">
        {#if !data.token}
          <li>
            <a
                    data-label="Home"
                    class="{sideBarIsOpen ? '' : 'menu-link'} group hover:bg-[#1A1F2E] transition duration-200 h-11 px-2 rounded-md flex items-center {$page.url.pathname.endsWith(`/${$locale}`) ? 'bg-[#1A1F2E]' : ''}"
                    href="/{$locale}"
            >
              <div class="min-w-8 w-8 h-8 flex items-center justify-center {$page.url.pathname.endsWith(`/${$locale}`) ? 'text-[#FF3E00]' : 'text-[#AAAAAA] group-hover:text-white'}">
                <HomeIcon css="w-5 h-5" />
              </div>
              {#if sideBarIsOpen}
                <span class="ml-3 {$page.url.pathname.endsWith(`/${$locale}`) ? 'text-white font-medium' : 'text-[#AAAAAA] group-hover:text-white'} transition-colors duration-200 truncate text-sm">{$translate('Home')}</span>
              {/if}
            </a>
          </li>
        {/if}

        <!-- Casino dropdown -->
        <li>
          <a
                  data-label="Casino"
                  href="/{$locale}/casino"
                  on:click={toggleSlotsDropdown}
                  class="group {sideBarIsOpen ? '' : 'menu-link'} w-full hover:bg-[#1A1F2E] transition duration-200 h-11 px-2 rounded-md flex items-center justify-between {casinoActive ? 'bg-[#1A1F2E]' : ''}"
          >
            <div class="flex items-center">
              <div class="min-w-7 w-7 h-7 flex items-center justify-center {casinoActive ? 'text-[#FF3E00]' : 'text-[#AAAAAA] group-hover:text-white'}">
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#55658c;}</style></defs><path class="cls-1" d="M4.41,21.26h2l1.89.35,2.45.46.47.08,4.61.86a2.07,2.07,0,0,0,.35,0A1.86,1.86,0,0,0,18,21.52l3.05-16.4a1.88,1.88,0,0,0-.3-1.4A1.82,1.82,0,0,0,19.56,3l-2.11-.39-1-.19a1.49,1.49,0,0,0-1.3-.77H12.29L12,1.54,9,1a1.89,1.89,0,0,0-1.75.61H4.41A1.48,1.48,0,0,0,3,2.6a1.33,1.33,0,0,0-.09.49V19.77A1.49,1.49,0,0,0,4.41,21.26ZM4.53,19,7.58,2.62a1.12,1.12,0,0,1,1.3-.9l2.43.45,1,.19,4.31.8.89.17,1.91.35a1.08,1.08,0,0,1,.72.47,1.11,1.11,0,0,1,.18.83l-3.05,16.4a1.1,1.1,0,0,1-.46.72,1.14,1.14,0,0,1-.84.18l-.71-.13-2.47-.46-2.3-.43-.15,0-4.91-.91A1.12,1.12,0,0,1,4.53,19Z"/><path class="cls-1" d="M8.47,12.21a2.25,2.25,0,0,0,3.18,2.44,2.6,2.6,0,0,1-1,1.43l.94.17.94.18a2.55,2.55,0,0,1-.38-1.67,2.25,2.25,0,0,0,1.22.66,2.83,2.83,0,0,0,.41,0,2.38,2.38,0,0,0,.88-.17A2.25,2.25,0,0,0,16,13.62c.26-1.41-.57-2.18-2.2-4.56a4.16,4.16,0,0,1-.42-.71,2,2,0,0,1-.21-.6,2.44,2.44,0,0,1-.68.72,3.22,3.22,0,0,1-.37.28C9.78,10.38,8.73,10.81,8.47,12.21Z"/></svg>
              </div>
              {#if sideBarIsOpen}
                <span class="ml-3 {casinoActive ? 'text-white font-medium' : 'text-[#AAAAAA] group-hover:text-white'} transition-colors duration-200 truncate text-sm">{$translate('Casino')}</span>
              {/if}
            </div>
            {#if sideBarIsOpen}
              <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="transition-transform duration-200 {slotsDropdownOpen ? 'rotate-180' : ''} {casinoActive ? 'text-[#FF3E00]' : 'text-[#AAAAAA]'}"
              >
                <path d="m6 9 6 6 6-6"/>
              </svg>
            {/if}
          </a>

          <!-- Dropdown items (only visible when sidebar is open) -->
          {#if sideBarIsOpen && slotsDropdownOpen}
            <div class="mt-1 space-y-1 pl-6">

              <!-- Lobby Casino subitem -->
              <a
                      href="/{$locale}/casino"
                      class="group flex items-center h-10 px-2 rounded-md hover:bg-[#1A1F2E] transition-all duration-200 {$page.url.pathname.endsWith(`/${$locale}/casino`) ? 'hover:bg-[#1A1F2E]' : ''}"
              >
                <div class="w-5 h-5 mr-2">
                  <svg viewBox="0 0 24 24" class="{$page.url.pathname.endsWith(`/${$locale}/casino`) ? 'text-[#FF3E00]' : 'text-[#576789] group-hover:text-white'}">
                    <path fill="currentColor" d="M18.67,2h-1.9a3,3,0,0,0-3.33,3.33v1.9a3,3,0,0,0,3.33,3.33h1.9A3,3,0,0,0,22,7.23V5.33A3,3,0,0,0,18.67,2Z"/>
                    <path fill="currentColor" d="M7.24,13.43H5.34A3,3,0,0,0,2,16.76v1.9A3,3,0,0,0,5.33,22h1.9a3,3,0,0,0,3.33-3.33v-1.9A3,3,0,0,0,7.24,13.43Z"/>
                    <path fill="currentColor" d="M6.29,10.58A4.29,4.29,0,1,0,2,6.29,4.29,4.29,0,0,0,6.29,10.58Z"/>
                    <path fill="currentColor" d="M17.71,22a4.29,4.29,0,1,0-4.29-4.29A4.29,4.29,0,0,0,17.71,22Z"/>
                  </svg>
                </div>
                <span class="text-sm {$page.url.pathname.endsWith(`/${$locale}/casino`) ? 'text-[#FF3E00]' : 'text-[#888] group-hover:text-white'} transition-colors duration-200">
                  {$translate('Lobby')}
                </span>
              </a>

              <!-- Slots subitem -->
              <a
                      href="/{$locale}/casino/slots"
                      class="group flex items-center h-10 px-2 rounded-md hover:bg-[#1A1F2E] transition-all duration-200 {$page.url.pathname.endsWith(`/${$locale}/casino/slots`) ? 'hover:bg-[#1A1F2E]' : ''}"
              >
                <div class="w-5 h-5 mr-2">
                  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#576789;}</style></defs><path class="cls-1" d="M20.75,9.1V6.48a1.88,1.88,0,1,0-1.25,0v2.6H17.83V2.63A.63.63,0,0,0,17.21,2H3.88a.63.63,0,0,0-.63.63v11L2.18,14.68a.67.67,0,0,0-.18.44v3.34a.63.63,0,0,0,.63.62h.62v2.29a.63.63,0,0,0,.63.63H16.79a.63.63,0,0,0,.63-.63V19.08h1a.62.62,0,0,0,.62-.62V15.12a.62.62,0,0,0-.18-.44l-1.07-1.06v-.78h2.71A1.47,1.47,0,0,0,22,11.38v-.84A1.45,1.45,0,0,0,20.75,9.1ZM15.54,4.29V7.8h-10V4.29Zm-10,4.53h10v5h-10ZM16.16,20.75H4.51V19.08H16.16Zm4.59-9.37a.21.21,0,0,1-.21.2H17.83V10.34h2.71a.21.21,0,0,1,.21.2Zm-.63-6.05a.62.62,0,1,1,.63-.62A.62.62,0,0,1,20.12,5.33Z"/><path class="cls-1" d="M14.29,5.55H6.8v1h7.49Z"/><path class="cls-1" d="M14.29,10.08H12.63v2.49h1.66Z"/><path class="cls-1" d="M11.37,10.08H9.71v2.49h1.66Z"/>
                    <path class="cls-1" d="M8.46,10.08H6.8v2.49H8.46Z"/>
                  </svg>
                </div>
                <span class="text-sm {$page.url.pathname.endsWith(`/${$locale}/casino/slots`) ? 'text-[#FF3E00]' : 'text-[#888] group-hover:text-white'} transition-colors duration-200">
                  {$translate('Slots')}
                </span>
              </a>

              <!-- Live Casino subitem -->
              <a
                      href="/{$locale}/casino/live-casino"
                      class="group flex items-center h-10 px-2 rounded-md hover:bg-[#1A1F2E] transition-all duration-200 {$page.url.pathname.endsWith(`/${$locale}/casino/live-casino`) ? 'hover:bg-[#1A1F2E]' : ''}"
              >
                <div class="w-5 h-5 mr-2">
                  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1,.cls-2{fill:#576789;}.cls-1{fill-rule:evenodd;}</style></defs><path class="cls-1" d="M14.77,12.37c0,2-2.77,10.53-2.77,10.53S9.23,14.5,9.23,12.37A5.59,5.59,0,0,0,6,13.52c-1.73,1.79-2.12,6.86-2.18,9.71H20.14c-.07-2.86-.47-7.94-2.21-9.72A5.46,5.46,0,0,0,14.77,12.37Z"/><path class="cls-1" d="M12,.77A4.54,4.54,0,0,0,7.51,4.2,10.9,10.9,0,0,0,8,8.91a4,4,0,0,0,4,3,4,4,0,0,0,4-3,11,11,0,0,0,.5-4.71A4.56,4.56,0,0,0,12,.77Z"/><path class="cls-2" d="M12.81,12.93a.15.15,0,0,1-.09,0,.16.16,0,0,1-.1,0,1.51,1.51,0,0,0-.62-.14,1.48,1.48,0,0,0-.62.14.16.16,0,0,1-.1,0,.15.15,0,0,1-.09,0l-1-.62-.1,0a.1.1,0,0,0-.09,0,.16.16,0,0,0-.07.07.18.18,0,0,0,0,.1v2.08c0,.14.17.25.28.17l1-.67V14a1.43,1.43,0,0,0,1.46,0v.06l1,.67.09,0a.17.17,0,0,0,.1,0,.16.16,0,0,0,.07-.07.16.16,0,0,0,0-.1V12.48c0-.14-.17-.25-.28-.17Z"/></svg>
                </div>
                <span class="text-sm {$page.url.pathname.endsWith(`/${$locale}/casino/live-casino`) ? 'text-[#FF3E00]' : 'text-[#888] group-hover:text-white'} transition-colors duration-200">
                  {$translate('Live Casino')}
                </span>
              </a>

              <!-- Mini Games subitem -->
              <a
                      href="/{$locale}/casino/mini-games"
                      class="group flex items-center h-10 px-2 rounded-md hover:bg-[#1A1F2E] transition-all duration-200 {$page.url.pathname.endsWith(`/${$locale}/casino/mini-games`) ? 'hover:bg-[#1A1F2E]' : ''}"
              >
                <div class="w-5 h-5 mr-2">
                  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#576789;}</style></defs><path class="cls-1" d="M12,2A10.12,10.12,0,0,0,2,12.18v7.89c0,1.26.75,1.6,1.67.76l1-.91a1,1,0,0,1,1.34,0l2,1.83a1,1,0,0,0,1.34,0l2-1.83a1,1,0,0,1,1.34,0l2,1.83a1,1,0,0,0,1.34,0l2-1.83a1,1,0,0,1,1.34,0l1,.91c.92.84,1.67.5,1.67-.76V12.18A10.18,10.18,0,0,0,12,2Zm0,4.62A2.38,2.38,0,1,1,9.6,9,2.39,2.39,0,0,1,12,6.62Zm4.45,8a7.47,7.47,0,0,1-8.9,0,.75.75,0,1,1,.9-1.2,5.94,5.94,0,0,0,7.1,0,.75.75,0,1,1,.9,1.2Z"/></svg>
                </div>
                <span class="text-sm {$page.url.pathname.endsWith(`/${$locale}/casino/mini-games`) ? 'text-[#FF3E00]' : 'text-[#888] group-hover:text-white'} transition-colors duration-200">
                  {$translate('Mini Games')}
                </span>
              </a>

            </div>
          {/if}
        </li>

        <li>
          <a
                  data-label="Level Up"
                  class="group {sideBarIsOpen ? '' : 'menu-link'} hover:bg-[#1A1F2E] transition duration-200 h-11 px-2 rounded-md flex items-center {$page.url.pathname.endsWith(`/${$locale}/level-up`) ? 'bg-[#1A1F2E]' : ''}"
                  href="/{$locale}/level-up"
          >
            <div class="min-w-8 w-8 h-8 flex items-center justify-center {$page.url.pathname.endsWith(`/${$locale}/level-up`) ? 'text-[#FF3E00]' : 'text-[#AAAAAA] group-hover:text-white'}">
              <LevelUpIcon css="w-5 h-5" />
            </div>
            {#if sideBarIsOpen}
              <span class="ml-3 {$page.url.pathname.endsWith(`/${$locale}/level-up`) ? 'text-white font-medium' : 'text-[#AAAAAA] group-hover:text-white'} transition-colors duration-200 truncate text-sm">{$translate('Level Up')}</span>
            {/if}
          </a>
        </li>

        <li>
          <a
                  data-label="Providers"
                  class="group {sideBarIsOpen ? '' : 'menu-link'} hover:bg-[#1A1F2E] transition duration-200 h-11 px-2 rounded-md flex items-center {$page.url.pathname.endsWith(`/${$locale}/providers`) ? 'bg-[#1A1F2E]' : ''}"
                  href="/{$locale}/providers"
          >
            <div class="min-w-8 w-8 h-8 flex items-center justify-center {$page.url.pathname.endsWith(`/${$locale}/providers`) ? 'text-[#FF3E00]' : 'text-[#AAAAAA] group-hover:text-white'}">
              <GridIcon css="w-5 h-5" />
            </div>
            {#if sideBarIsOpen}
              <span class="ml-3 {$page.url.pathname.endsWith(`/${$locale}/providers`) ? 'text-white font-medium' : 'text-[#AAAAAA] group-hover:text-white'} transition-colors duration-200 truncate text-sm">{$translate('Providers')}</span>
            {/if}
          </a>
        </li>

        <li>
          <a
                  data-label="Promotions"
                  class="group {sideBarIsOpen ? '' : 'menu-link'} hover:bg-[#1A1F2E] transition duration-200 h-11 px-2 rounded-md flex items-center {$page.url.pathname.endsWith(`/${$locale}/promotions`) ? 'bg-[#1A1F2E]' : ''}"
                  href="/{$locale}/promotions"
          >
            <div class="min-w-8 w-8 h-8 flex items-center justify-center {$page.url.pathname.endsWith(`/${$locale}/promotions`) ? 'text-[#FF3E00]' : 'text-[#AAAAAA] group-hover:text-white'}">
              <PromotionsIcon css="w-5 h-5" />
            </div>
            {#if sideBarIsOpen}
              <span class="ml-3 {$page.url.pathname.endsWith(`/${$locale}/promotions`) ? 'text-white font-medium' : 'text-[#AAAAAA] group-hover:text-white'} transition-colors duration-200 truncate text-sm">{$translate('Promotions')}</span>
            {/if}
          </a>
        </li>
      </ul>
    </div>

    <!-- Enhanced Support section at the bottom -->
    <div class="border-t border-[#1A1F2E] bg-[#191D25] p-2 mt-auto">
      <button
              on:click={() => openChat()}
              data-label="Live Support"
              class="group {sideBarIsOpen ? '' : 'menu-link'} w-full hover:bg-[#1A1F2E] transition duration-200 cursor-pointer flex items-center h-11 px-2 rounded-md"
      >
        <div class="min-w-8 w-8 h-8 flex items-center justify-center text-[#FFD700]">
          <SupportIcon css="w-5 h-5" />
        </div>
        {#if sideBarIsOpen}
          <span class="ml-3 text-[#FFD700] font-medium truncate text-sm" id="openChatButton">{$translate('Live Support')}</span>
        {/if}
      </button>
    </div>
  </aside>
</div>

<style lang="scss">
  aside {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.3);
  }

  .menu-link {
    position: relative;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover::after {
      content: attr(data-label);
      position: absolute;
      left: 100%;
      top: 50%;
      transform: translateY(-50%);
      margin-left: 0.75rem;
      padding: 0.5rem 0.75rem;
      background-color: #1A1F2E;
      color: white;
      font-size: 0.875rem;
      border-radius: 0.375rem;
      white-space: nowrap;
      z-index: 50;
      box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
    }

    &:hover::before {
      content: '';
      position: absolute;
      left: 100%;
      top: 50%;
      transform: translateY(-50%);
      border-width: 6px;
      border-style: solid;
      border-color: transparent #1A1F2E transparent transparent;
      margin-left: 0.25rem;
      z-index: 50;
    }
  }

  @keyframes shimmer {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }
</style>